import '../../../../../../motion-utils/dist/es/errors.mjs';
import { progress } from '../../../../../../motion-utils/dist/es/progress.mjs';

const generateLinearEasing = (easing, duration, // as milliseconds
resolution = 10 // as milliseconds
) => {
    let points = "";
    const numPoints = Math.max(Math.round(duration / resolution), 2);
    for (let i = 0; i < numPoints; i++) {
        points += easing(progress(0, numPoints - 1, i)) + ", ";
    }
    return `linear(${points.substring(0, points.length - 2)})`;
};

export { generateLinearEasing };
